<script lang="ts">
	import { beforeNavigate } from '$app/navigation';
	import { createCollapsible, melt } from '@melt-ui/svelte';
	import { ChevronDown, ChevronUp } from 'lucide-svelte';
	import { createEventDispatcher } from 'svelte';
	import { writable } from 'svelte/store';

	const customOpen = writable(false);
	export { customOpen as open };

	const dispatch = createEventDispatcher();
	const {
		elements: { root, content, trigger },
		states: { open }
	} = createCollapsible({
		open: customOpen,
		onOpenChange: ({ next }) => {
			dispatch('openchange', { open: customOpen });
			return next;
		}
	});

	interface Props {
		title: string;
		titleClass?: string;
		class?: string;
		children?: import('svelte').Snippet;
	}

	let { title, titleClass = 'index-bold', class: clazz = '', children }: Props = $props();

	beforeNavigate(() => {
		$open = false;
	});
</script>

<div use:melt={$root} class={clazz}>
	<button use:melt={$trigger} class="text-green-dark flex items-center gap-2">
		<span class={titleClass}>
			{title}
		</span>
		{#if $open}
			<ChevronUp class="w-6" />
		{:else}
			<ChevronDown class="w-6" />
		{/if}
	</button>

	{#if $open}
		<div use:melt={$content}>
			{@render children?.()}
		</div>
	{/if}
</div>

<style lang="postcss">
	@reference '../app.css';
	.open {
		@apply z-20 rounded-b-none;
	}
</style>
